export default function getAdPlaying(state) {
  return state.ads.adPlaying;
}
